import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faCar, faComment, faDownload, faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastaConfig, ToastaService } from 'ngx-toasta';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { TipoToasta } from 'src/app/enums/Toasta.enum';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { CatalagosConfig } from 'src/app/models/CatalogosConfig';
import { ColumnDefinition } from 'src/app/models/colDef.model';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { NotificationService } from 'src/app/services/Notification.service';
import { UtilsService } from 'src/app/services/Utils.service';
import { DialogConfirmacion } from '../../../../../shared/dialogs/confirmacion/dialogConfirmacion.component';
//Las directivas extras.
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DateAdapter } from '@angular/material/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DialogSubirArchivo } from '../Dialog/dialogSubirArchivo.component';
import { TableArchivosAdjuntos } from '../Tables/tableArchivosAdjuntos.component';
import { dialogAddComponenteOrdenTaller } from './dialogAddComponenteOrdenTaller.component';

import { TableOrdenDeTallerDetalle } from '../Tables/tableOrdenDeTallerDetalle.component';

export interface PeriodicElement {
  nombre: string;
  descripcion: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { nombre: 'accion', descripcion: '1.007' },
  { nombre: 'nombre', descripcion: '4.0026' },
  { nombre: 'descripcion', descripcion: '6.941' },
];

@Component({
  selector: 'app-DialogOrdenTallerComponent',
  templateUrl: './../../Views/Dialogs/dialogOrdenTaller.component.html',
  //styleUrls: [ './../../Styles/ordenDeTaller.component.scss', './../../../../../theme/styles/_common.scss']
  styleUrls: ['./../../Styles/ordenDeTaller.component.scss']
})
export class DialogOrdenTallerComponent implements OnInit {
  public catConfig: CatalagosConfig = new CatalagosConfig();
  public settings: Settings;
  public displayToasta: boolean = true;
  public opciones: ToastaService;
  public configuraciones: ToastaConfig;
  public permisoDetalle: any = {};
  public permisoPantalla: any;
  public dateFecha: FormControl = new FormControl(new Date(this.utilsSrv.GetLocalISODate(Date.now()).replace(/-/g, "/")));
  public deshabilitaGuardar: boolean = true;
  public connSvc: httpConnect;
  public icons: any = {
    addCircle: faPlusCircle,
    add: faPlus,
    comment: faComment,
    car: faCar,
    download: faDownload
  };
  public NameController: string = 'OrdenDeTaller';


  public _fechaRegistroISO: string = this.utilsSrv.GetLocalISODateTime(Date.now()).slice(0, 19); // 2022-03-06 (aaangeles)
  public _registradoPor: string = this.myStorage.getItem("nombre_personal");
  public hora: string = "00:00";
  public fechaISO: string = '';
  public horaProgramacion: string = "00:00";
  public fechaProgramacionISO: string = '';
  public timeSpan: Date = new Date();

  @ViewChild(TableOrdenDeTallerDetalle) tableOrdenTallerDetalle: TableOrdenDeTallerDetalle;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  @ViewChild(TableArchivosAdjuntos) tblArchivosAdjuntos: TableArchivosAdjuntos;

  //Secciones formControls
  public fechaCaptura = new FormControl(new Date(this.utilsSrv.GetLocalISODate(Date.now()).replace(/-/g, "/")));
  public fechaInicio = new FormControl(new Date(this.utilsSrv.GetLocalISODate(Date.now()).replace(/-/g, "/")));
  public horaInicio = new FormControl();
  public fechaFin = new FormControl(new Date(this.utilsSrv.GetLocalISODate(Date.now()).replace(/-/g, "/")));
  public horaFin = new FormControl();
  //Entities
  //Información principal.
  //Catalog
  //Datos Generales.
  public UnidadList: Array<any> = [];
  public UnidadSelected: any = {};
  public unidadInfo = {
    idUnidad: 0,
    tipounidad: null,
    marca: null,
    modelo: null,
    placas: null,
    unidadlectura: null,
    kmdia: null,
    kmactual: null
  }
  public proveedorSelected: any = {};
  public facturaSelected: any = {};

  public estatusTallerSelected: any = {};
  public tipoMttoSelected: any = {};
  public servicioSelected: any = {};

  //Seccion tabla de componentes.
  public accionSelected: any = {};
  public sistemaSelected: any = {};
  public componenteSelected:  any = {};
  public refaccionSelected: any = {};
  public unidadMedidaSelected: any = {};
  public servicio: any = {};
  //Entities de pantalla para mandar a base de datos.
  //Transportes_orden_taller
  public orden: any = {
    id_orden: -1,
    fecha_captura: null,
    folio: "0",
    id_unidad: 0,
    no_economico: null,
    tipounidad: null,
    marca: null,
    modelo: null,
    placas: null,
    unidadlectura: null,
    kmdia: null,
    kmactual: null,
    id_tipo_mtto: 0,
    tipo_mtto: null,
    fecha_inicio: null,
    hora_inicio: "00:00",
    fecha_fin: null,
    hora_fin: "00:00",
    observaciones: '',
    id_registradopor: 0,
    fecha_registro: null,
    id_estatus_taller: 0,
    estatus_taller: null,
    id_servicio: 0,
    servicio: null,
    id_estatus: 1,
    estatus: null,
    estatus_color: null,
    estatus_texto: null
  };

  public proveedor: any = {
    id_orden_proveedor: 0,
    id_orden: 0,
    id_proveedor: 0,
    razon_social: null,
    rfc: null,
    calle: null,
    correo_electronico: null,
    no_exterior: null,
    no_interior: null,
    telefono: null,
    codigo_postal: null,
    pais: null,
    colonia: null,
    estado: null,
    uso_cfdi: null,
    municipio: null,
    factura: null,
    subtotal: 0.00,
    total_descuento: 0.00,
    factor_iva: 16,
    total_iva: 0.00,
    total_factura: 0.00,
    id_proveedor_direccion: 0,
    id_proveedor_contacto: 0
  };

  public refaccionesList: any = [];
  public fallasUnidad: any = [];
  public realizarCalculo: boolean = true;
  public adjuntos: any = [];

  public Cambios: any[] = [];

  //Seccion para subir archivos.
  public displayedColumns: string[] = ['nombre', 'descripcion'];
  public _archivosOrdenTaller: Array<any> = new Array<any>();
  public _archivosOrdenTallerFinal: Array<any> = new Array<any>();
  public tipoDocumento: string;
  DT_archivos = ELEMENT_DATA;
  colDef: Array<ColumnDefinition> = [
    { columnDef: "boton_editar", header: "", align: "left", visible: true, width: "60px", cellTemplate: "editar", cellMask: "", cell: (celda: any) => `${celda.boton_editar}`, cellDisabled: () => false },
    { columnDef: "boton_eliminar", header: "", align: "left", visible: true, width: "60px", cellTemplate: "eliminar", cellMask: "", cell: (celda: any) => `${celda.boton_eliminar}`, cellDisabled: () => false, class: () => 'icon-delete' },
    { columnDef: "nombre", header: "Nombre", align: "left", visible: true, width: "200px", cellTemplate: "default", cellMask: "", cell: (celda: any) => `${celda.nombre}` },
    { columnDef: "descripcion", header: "Descripción", align: "left", visible: true, width: "400px", cellTemplate: "default", cellMask: "", cell: (celda: any) => `${celda.descripcion}` },
  ]

  //Variables Generales.
  claseEstatus = "estatusEdicion";
  estatusTexto = "Edición";
  idEstatus: number = 1;

  messageObj = [{}, {}, {
    claseEstatus: 'estatusAceptado',
    estatusTexto: 'Aprobado',
    idEstatus: 2,
    askMessage: "¿Está seguro que desea aprobar la orden de taller?",
    messageResponse: "Se aprobó la orden con folio: "
  },
  {
    claseEstatus: 'estatusCancelado',
    estatusTexto: 'Cancelado',
    idEstatus: 3,
    askMessage: "¿Está seguro que desea cancelar la orden de taller?",
    messageResponse: "Se canceló la orden con folio: "
  }]

  dataP = {
    idUsuario: 1,
    idPermiso: 1,
    accion: 1,
    ordenTaller: []
  }

  constructor(
    public dialogRef: MatDialogRef<DialogOrdenTallerComponent>,
    public myStorage: AppOAuthStore,
    public utilsSrv: UtilsService,
    private httpConn: httpConnect,
    public appSettings: AppSettings,
    public dialog: MatDialog,
    private toastaService: ToastaService,
    private toastaConfig: ToastaConfig,
    private Notificacion: NotificationService,
    private dateAdapter: DateAdapter<Date>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.settings = this.appSettings.settings;
    this.configuraciones = this.toastaConfig;
    this.opciones = this.toastaService;
    this.connSvc = this.httpConn;
    this.Notificacion = new NotificationService(this.opciones, this.configuraciones);

    this.orden.id_orden = data.info?.orden_id_orden || 0;
    this.servicio = data.servicio || {};
    this.dateAdapter.setLocale('es-MX');
  }

  ngOnInit() {
    this.permisoPantalla = JSON.parse(this.myStorage.getItem("permisos")).find(p => p.id_permiso === 17 && p.id_modulo === 5);
    this.orden.id_orden == 0 ? this.NuevaEntrada() : this.GetDetallesOrdenDeTaller();
    this.servicio.hasOwnProperty('id') ? this.SetServicioProgramado() : null;
    //this.inicializaFb();
  }

  ngAfterViewInit() {
  }

  private SetServicioProgramado() {
    this.UnidadSelected = {
      id: this.servicio.id_unidad,
      value: this.servicio.no_economico
    };
    this.tipoMttoSelected = {
      id: this.servicio.id_tipo_mtto,
      value: this.servicio.tipo_mtto
    }
    this.getUnidadInfo(this.servicio.id_unidad)
    .subscribe(res => {
      this.unidadInfo = res;
    })
    // this.servicioSelected = {
    //   id: this.servicio.id_tipo_servicio,
    //   value: this.servicio.tipo_servicio
    // };
  }

  public NuevaEntrada() {
    this.orden.id_orden = -1;
    this.orden.id_estatus = 1;
    this.fechaISO = this.fechaCaptura.value.toISOString().slice(0, 10);
    this.hora = this.utilsSrv.GetLocalISODateTime(Date.now()).slice(0, 19).split('T')[1].substring(0, 5);
    this.fechaProgramacionISO = this.fechaCaptura.value.toISOString().slice(0, 10);
    this.horaProgramacion = this.utilsSrv.GetLocalISODateTime(Date.now()).slice(0, 19).split('T')[1].substring(0, 5);
    //Seccion tabla de componentes.
    this.UnidadSelected = {};
    this.proveedorSelected = {};
    this.estatusTallerSelected = {};
    this.tipoMttoSelected = {};
    this.servicioSelected = {};
  }

  //Obtener datos de la fila seleccionada para mostrarlos en pantalla.
  public GetDetallesOrdenDeTaller() {
    this.settings.loadingSpinner = true;
    this._archivosOrdenTaller = [];
    this._archivosOrdenTallerFinal = [];
    let params = { id_ordenDeTaller: this.orden.id_orden }
    // console.log(params);
    this.connSvc.postAPI(this.NameController, "GetOrdenDeTaller", params)
      .subscribe(data => {
        if (data.success) {
          this.orden = data.response['orden'];
          this.proveedor = data.response['proveedor'];
          this.AgregarListadoRefacciones(data.response['refacciones'])
          this._archivosOrdenTaller = data.response['adjuntos'];
          this._archivosOrdenTallerFinal = [... this._archivosOrdenTaller];
          this.setDataInfo();
        } else {
          this.Notificacion.ShowToasta(data.message, TipoToasta.ERROR);
        }
      }, error => {
        this.Notificacion.ShowToasta(error.error.message || error.message, TipoToasta.ERROR);
      }).add(() => {
        this.settings.loadingSpinner = false;
      });
  };

  public setDataInfo() {
    this.fallasUnidad = [];
    this.validaEstatus();
    this.getUnidadInfo(this.orden.id_unidad)
      .subscribe(res => {
        this.unidadInfo = res;
      })
    this.getOrdenTallerFallaUnidad(this.orden.id_unidad)
      .subscribe(res => {
        this.AgregarReporteFallasList(res.response);
      });
    this.UnidadSelected = {
      id: this.orden.id_unidad,
      value: this.orden.no_economico
    };
    this.proveedorSelected = {
      id_proveedor: this.proveedor.id_proveedor,
      proveedor: this.proveedor.razon_social
    };
    this.estatusTallerSelected = {
      id: this.orden.id_estatus_taller,
      value: this.orden.estatus_taller
    };
    this.tipoMttoSelected = {
      id: this.orden.id_tipo_mtto,
      value: this.orden.tipo_mtto
    }
    this.servicioSelected = {
      id: this.orden.id_servicio,
      value: this.orden.servicio
    };
    this._fechaRegistroISO = this.orden.fecha_registro;
    this._registradoPor = this.orden.registradoPor;
    this.fechaCaptura = new FormControl(new Date(this.orden.fecha_captura));
    this.fechaInicio = new FormControl(new Date(this.orden.fecha_inicio));
    this.horaInicio = new FormControl(this.orden.hora_inicio);
    this.fechaFin = new FormControl(new Date(this.orden.fecha_fin));
    this.horaFin = new FormControl(this.orden.hora_fin);

    this.fechaISO = this.fechaCaptura.value.toISOString().slice(0, 10);
    this.hora = this.orden.fecha_registro.split(' ')[1].substring(0, 5);
    this.fechaProgramacionISO = this.fechaCaptura.value.toISOString().slice(0, 10);
    this.horaProgramacion = this.orden.fecha_registro.split(' ')[1].substring(0, 5);

    //this._archivosOrdenTaller = this.adjuntos;
  };

  //Seccion llenar los catalogos.
  //Rutina principal.
  public AC_BindCatalogo(value: string, nameCatalogo: string, padreId?: number): Observable<any[]> {
    return this.connSvc.postAPI('General', 'ACCatalogos_ConsultaXDesc', { catalogo: nameCatalogo, value: value, padreId: padreId })
      .pipe(map(res => res.success ? res.response : throwError(res.message), catchError(err => throwError(err))));
  }

  //Rutina por catalogo.
  public AC_BindCatalogoEspecial(value: string, nameCatalogo: string, padreId?: number): Observable<any[]> {
    return this.connSvc.postAPI(this.NameController, 'ACProveedorInfo', { catalogo: nameCatalogo, value: value, padreId: padreId })
      .pipe(map(res => res.success ? res.response : throwError(res.message), catchError(err => throwError(err))));
  }
  public AC_Proveedores(value: string): Observable<any[]> {
    return this.AC_BindCatalogoEspecial(value, 'transportes_proveedor_info', -1)
  }

  public proveedorSelect(value) {
    this.proveedorSelected = value;
    this.orden.id_proveedor= this.proveedorSelected.id_proveedor;
    this.proveedor.id_proveedor = this.proveedorSelected.id_proveedor;
    this.proveedor.id_proveedor_direccion = this.proveedorSelected.id_proveedor_direccion;
    this.proveedor.id_proveedor_contacto = this.proveedorSelected.id_proveedor_contacto;
    this.proveedor.razon_social = this.proveedorSelected.razon_social;
    this.proveedor.rfc = this.proveedorSelected.rfc;
    this.proveedor.calle = this.proveedorSelected.calle;
    this.proveedor.correo_electronico = this.proveedorSelected.correo_electronico;
    this.proveedor.no_exterior = this.proveedorSelected.no_exterior;
    this.proveedor.no_interior = this.proveedorSelected.no_interior;
    this.proveedor.telefono = this.proveedorSelected.telefono;
    this.proveedor.codigo_postal = this.proveedorSelected.codigo_postal;
    this.proveedor.pais = this.proveedorSelected.pais;
    this.proveedor.colonia = this.proveedorSelected.colonia;
    this.proveedor.estado = this.proveedorSelected.estado;
    this.proveedor.uso_cfdi = this.proveedorSelected.uso_cfdi;
    this.proveedor.municipio = this.proveedorSelected.municipio;
  }


  //Acciones
  public AC_Acciones(value: string): Observable<any[]> {
    return this.AC_BindCatalogo(value, 'transportes_accion', -1)
  }

  public accionSelect(com, value) {
    this.accionSelected = value;
  }
  //Sistemas
  public AC_Sistemas(value: string): Observable<any[]> {
    return this.AC_BindCatalogo(value, 'transportes_sistema', -1)
  }

  public sistemaSelect(com, value) {
    this.sistemaSelected = value;
  }

  //Componentes
  public AC_Componentes(value: string): Observable<any[]> {
    return this.AC_BindCatalogo(value, 'transportes_componente_p', this.sistemaSelected.id )
  }

  public componenteSelect(com, value) {
    this.componenteSelected = value;
  }

  //Refacciones
  public AC_Refacciones(value: string): Observable<any[]> {
    return this.AC_BindCatalogo(value, 'transportes_refaccion', -1)
  }

  public refaccionSelect(com, value) {
    this.refaccionSelected = value;
  }

  //Unidad de Medida
  public AC_UnidadMedida(value: string): Observable<any[]> {
    return this.AC_BindCatalogo(value, 'general_unidad_medida', -1)
  }

  public unidadMedidaSelect(com, value) {
    this.unidadMedidaSelected = value;
  }

  //Agregar componente nuevo.
  public ConfirmaAgregarComponente() {
    if (this.refaccionesList.filter(i => i.editar).length > 0) {
      this.Notificacion.ShowToasta("No es posible agregar un nuevo componente. Existe un registro en edición.", TipoToasta.ADVERTENCIA);
      return;
    }
    let dialogRef = this.dialog.open(DialogConfirmacion, {
      data: {
        titulo: 'AGREGAR COMPONENTE',
        mensaje: "¿Desea agregar un nuevo componente?",
        tipo: 5,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.displayToasta = true;
      if (result.confirm) {
        this.AgregarRefaccionNueva();
      }
    });
  }

  private AgregarRefaccionNueva() {
    this.refaccionesList.push({
      editar: true,
      nuevo: true,
      id_orden_refaccion: 0,
      id_orden: 0,
      id_accion: 0,
      accion: null,
      id_sistema: 0,
      sistema: null,
      id_componente: 0,
      componente: null,
      id_refaccion: 0,
      refaccion: null,
      cantidad: 0,
      id_unidadmedida: 0,
      unidadmedida: null,
      precio_unitario: 0,
      importe: 0,
      factor_descuento: 0,
      monto_descuento: 0,
      total: 0,
      id_falla: 0,
      id_falla_detalle: 0,
      acciones: "I"
    })
    this.accionSelected = {};
    this.sistemaSelected = {};
    this.componenteSelected = {};
    this.refaccionSelected = {};
    this.unidadMedidaSelected = {};
    this.refaccionesList = [...this.refaccionesList];
  }

  //Eventos para tabla de componentes.
  EditRefaccion(ref) {
    if (this.refaccionesList.filter(i => i.editar).length > 0) return;
    ref.editar = true;
    this.accionSelected = {
      id: ref.id_accion,
      value: ref.accion
    };
    this.sistemaSelected = {
      id: ref.id_sistema,
      value: ref.sistema
    };
    this.componenteSelected = {
      id: ref.id_componente,
      value: ref.componente
    };
    this.refaccionSelected = {
      id: ref.id_refaccion,
      value: ref.refaccion
    };
    this.unidadMedidaSelected = {
      id: ref.id_unidadmedida,
      value: ref.unidadmedida
    };

    //Operaciones de productos.
    this.CalcularTotalRefaccion(ref);
    this.CalcularMontoTotal(this.refaccionesList);
  }

  EditRefaccionEspecial(ref) {
    if (this.refaccionesList.filter(i => i.editar).length > 0) return;
    ref.editar = true;
    this.accionSelected = {
      id: ref.id_accion,
      value: ref.accion
    };
    this.sistemaSelected = {
      id: ref.id_sistema,
      value: ref.sistema
    };
    this.componenteSelected = {
      id: ref.id_componente,
      value: ref.componente
    };
    this.refaccionSelected = {
      id: ref.id_refaccion,
      value: ref.refaccion
    };
    this.unidadMedidaSelected = {
      id: ref.id_unidadmedida,
      value: ref.unidadmedida
    };
    this.realizarCalculo = false;
  }

  SaveRefaccion(ref) {
    if (!this.accionSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Es necesario indicar una acción.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (!this.sistemaSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Es necesario indicar un sistema.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (!this.componenteSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Es necesario indicar un componente.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (!this.refaccionSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Es necesario indicar una refacción.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (!this.unidadMedidaSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Debe seleccionar una unidad de medida para crear orden de taller.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (this.refaccionesList.filter(i => i.id_accion == this.accionSelected.id && i.id_sistema == this.sistemaSelected.id && i.id_componente == this.componenteSelected.id && i.id_refaccion == this.refaccionSelected.id && i.editar == false).length > 0) {
      this.Notificacion.ShowToasta("Ya se ha registrado una refacción para la orden de taller. Favor de validar.", TipoToasta.ADVERTENCIA);
      return;
    };
    if (ref.cantidad > 0) {
      if (ref.precio_unitario > 0) {
        if ((ref.factor_descuento >= 0) && (ref.factor_descuento <= 100)) {
          ref.editar = false;
          ref.nuevo = false;
          ref.id_accion = this.accionSelected.id;
          ref.accion = this.accionSelected.value;
          ref.id_sistema = this.sistemaSelected.id;
          ref.sistema = this.sistemaSelected.value;
          ref.id_componente = this.componenteSelected.id;
          ref.componente = this.componenteSelected.value;
          ref.id_refaccion = this.refaccionSelected.id;
          ref.refaccion = this.refaccionSelected.value;
          ref.id_unidadmedida = this.unidadMedidaSelected.id;
          ref.unidadmedida = this.unidadMedidaSelected.value;
          this.CalcularTotalRefaccion(ref);
          //Operaciones de productos.
          this.ValidarDatosListaComponentes(this.refaccionesList);
          this.CalcularMontoTotal(this.refaccionesList);
        } else {
          this.Notificacion.ShowToasta("El Descuento debe estar entre el rango del 0 al 100 porciento.", TipoToasta.ADVERTENCIA);
          return;
        };
      }
      else {
          ref.editar = false;
          ref.nuevo = false;
          ref.id_accion = this.accionSelected.id;
          ref.accion = this.accionSelected.value;
          ref.id_sistema = this.sistemaSelected.id;
          ref.sistema = this.sistemaSelected.value;
          ref.id_componente = this.componenteSelected.id;
          ref.componente = this.componenteSelected.value;
          ref.id_refaccion = this.refaccionSelected.id;
          ref.refaccion = this.refaccionSelected.value;
          ref.id_unidadmedida = this.unidadMedidaSelected.id;
          ref.unidadmedida = this.unidadMedidaSelected.value;
          ref.factor_descuento = 0
          ref.importe = 0;
          ref.monto_descuento = 0;
          ref.total = 0;
          //Operaciones de productos.
          this.ValidarDatosListaComponentes(this.refaccionesList);
          this.CalcularMontoTotal(this.refaccionesList);
      };
    } else {
      this.Notificacion.ShowToasta("No se ha especificado la cantidad de refacciones.", TipoToasta.ADVERTENCIA);
      return;
    };
  }

  UndoChanges(ref) {
    if (ref.nuevo) {
      this.refaccionesList = this.refaccionesList.filter(i => !i.nuevo);
      return;
    };
    //Cerrar editar fila.
    ref.editar = false;
    this.ValidarDatosListaComponentes(this.refaccionesList);
    //Operaciones de Productos.
    if(this.realizarCalculo) {
      this.CalcularTotalRefaccion(ref);
      this.CalcularMontoTotal(this.refaccionesList);
    }
  }

  DeleteRefaccion(ref) {
    //Eliminar fila
    this.refaccionesList = this.refaccionesList.filter(i => i != ref);
    this.refaccionesList = [...this.refaccionesList];
    this.ValidarDatosListaComponentes(this.refaccionesList);
    //Operaciones de Productos.
    if (this.realizarCalculo) {
      this.CalcularTotalRefaccion(ref);
      this.CalcularMontoTotal(this.refaccionesList);
    }
  }

  public CalcularTotalRefaccion(ref) {
    ref.importe = 0;
    ref.monto_descuento = 0;
    ref.total = 0;
    if (ref.cantidad > 0 && ref.precio_unitario > 0) {
      ref.importe = ref.precio_unitario * ref.cantidad;
      ref.importe = this.redondearDecimales(ref.importe, 2);
      if (ref.factor_descuento > 0) {
        ref.monto_descuento = ref.importe * (ref.factor_descuento / 100);
        ref.monto_descuento = this.redondearDecimales(ref.monto_descuento, 2);
      }
      ref.total = ref.importe - ref.monto_descuento;
      ref.total = this.redondearDecimales(ref.total, 2);
    } else {
      this.displayToasta = true;
      this.Notificacion.ShowToasta("Validar la cantidad de refacciones.", TipoToasta.ADVERTENCIA);
      return;
    };
  }

  public CalcularMontoTotal(arr: Array<any>) {
    this.proveedor.subtotal = 0;
    this.proveedor.total_descuento = 0;
    this.proveedor.total_iva = 0;
    this.proveedor.total_factura = 0;
    for (const val of arr) {
      //Realizar operaciones para calcular el total de la factura.
      if (val.total >= 0) {
        this.proveedor.subtotal = (this.proveedor.subtotal + val.total);
        this.proveedor.total_descuento = (this.proveedor.total_descuento + val.monto_descuento);
      }
      else {
        this.displayToasta = true;
        this.Notificacion.ShowToasta("Validar el total de un componente.", TipoToasta.ADVERTENCIA);
        this.proveedor.subtotal = 0;
        this.proveedor.total_descuento = 0;
        this.proveedor.total_iva = 0;
        this.proveedor.total_factura = 0;
        return;
      }
    }
    this.proveedor.total_iva = (this.proveedor.subtotal) * (.16)
    this.proveedor.total_factura = (this.proveedor.subtotal) + this.proveedor.total_iva;
    //Redondear valores decimales.
    this.proveedor.subtotal = this.redondearDecimales(this.proveedor.subtotal, 2);
    this.proveedor.total_descuento = this.redondearDecimales(this.proveedor.total_descuento, 2);
    this.proveedor.total_iva = this.redondearDecimales(this.proveedor.total_iva, 2);
    this.proveedor.total_factura = this.redondearDecimales(this.proveedor.total_factura, 2);
  }

  public redondearDecimales(numero, decimales) {
    var numeroRegexp = new RegExp('\\d\\.(\\d){' + decimales + ',}');   // Expresion regular para numeros con un cierto numero de decimales o mas
    if (numeroRegexp.test(numero)) {         // Ya que el numero tiene el numero de decimales requeridos o mas, se realiza el redondeo
      return Number(numero.toFixed(decimales));
    } else {
      return Number(numero.toFixed(decimales)) === 0 ? 0 : numero;  // En valores muy bajos, se comprueba si el numero es 0 (con el redondeo deseado), si no lo es se devuelve el numero otra vez.
    }
  }

  //SECCION PARA GUARDAR ORDEN DE TALLER.
  public _hayCambios: boolean = false;
  public _accion: string = ";"
  public ConfirmaGuardar(accion: number) {
    if (!this.UnidadSelected.hasOwnProperty('id')) {
      this.Notificacion.ShowToasta("Debe seleccionar un Número de unidad.", TipoToasta.ADVERTENCIA);
      return;
    }
    if (!this.proveedorSelected.hasOwnProperty('id_proveedor')) {
      this.Notificacion.ShowToasta("Debe seleccionar un Proveedor.", TipoToasta.ADVERTENCIA);
      return;
    }
    // if (this.proveedor.factura == null || this.proveedor.factura == '') {
    //   this.Notificacion.ShowToasta("Debe agregar un Número de factura.", TipoToasta.ADVERTENCIA);
    //   return;
    // }
    if (this.refaccionesList.length == 0) {
      this.Notificacion.ShowToasta("La lista de componentes se encuentra vacía.", TipoToasta.ADVERTENCIA);
      return;
    }
    if (this.refaccionesList.filter(i => i.editar).length > 0) {
      this.Notificacion.ShowToasta("Existe un registro en edición, favor de guardarlo.", TipoToasta.ADVERTENCIA);
      return;
    }
    let data = {
      titulo: 'Guardar',
      mensaje: "¿Desea guardar los datos capturados?",
      tipo: 5,
    };
    switch (accion) {
      case 1:
        data.mensaje = "¿Desea guardar los datos capturados?";
        break;
      case 2:
        data.titulo = "Aprobar";
        data.mensaje = "¿Desea aprobar la orden de taller?";
        data.tipo = 3;
        break;
      case 3:
        data.titulo = "Cancelar";
        data.mensaje = "Atencion esta a punto de cancelar la orden de taller, ¿Continuar?";
        data.tipo = 3;
        break;
      default: break;
    }
    let dialogRef = this.dialog.open(DialogConfirmacion, {
      data: data,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.displayToasta = true;
      if (result.confirm) {
        if (this.UnidadSelected.id == 0) { this.UnidadSelected.id = this.orden.id_unidad; }
        this.SetInformacionOrden();
        switch (accion) {
          case 1: this._accion = "Guardar"; break;
          case 2: this._accion = "Aprobar"; break;
          case 3: this._accion = "Cancelar"; break;
          default: break;
        }
        this.Cambios = this.refaccionesList;
        this.ValidarArchivosAdjuntos();
        this.Guardar();
      }
    });
  }

  public ValidarArchivosAdjuntos() {
    if (this._archivosOrdenTallerFinal.length >= 1) {
      for (const val of this._archivosOrdenTallerFinal) {
        if (this._archivosOrdenTaller.filter(i => i.nombre == val.nombre && i.consecutivo == val.consecutivo).length > 0) {
          val.acciones = 'U';
        } else {
          val.acciones = 'D';
        }
      }
      for (const aot of this._archivosOrdenTaller) {
        if (aot.acciones == 'I') {
          if (this._archivosOrdenTallerFinal.filter(i => i.consecutivo == aot.consecutivo).length > 0) {
            aot.rowNo = this._archivosOrdenTallerFinal[this._archivosOrdenTallerFinal.length - 1].rowNo + 1;
            aot.consecutivo = this._archivosOrdenTallerFinal[this._archivosOrdenTallerFinal.length - 1].consecutivo + 1;
          }
          this._archivosOrdenTallerFinal.push(aot);
        }
      }
    } else {
      this._archivosOrdenTallerFinal = [... this._archivosOrdenTaller];
    }
  }
  public Guardar() {
    this.settings.loadingSpinner = true;
    let params = {
      OrdenDeTaller: this.orden,
      OrdenDeTallerProveedor: this.proveedor,
      OrdenDeTallerComponenteRefaccion: this.Cambios,
      OrdenDeTallerAdjunto: this._archivosOrdenTallerFinal,
      ps_Accion: this._accion,
      id_plan: this.servicio.id || 0
    }
    // console.log(params);
    this.connSvc.postAPI(this.NameController, 'SetOrdenDeTaller', params)
      .subscribe(data => {
        // console.log('response SetOrdenDeTaller->',data);
        if (data.success) {
          this._archivosOrdenTaller = [];
          this._archivosOrdenTallerFinal = [];
          this.orden = data.response['orden'];
          this.proveedor = data.response['proveedor'];
          this.AgregarListadoRefacciones(data.response['refacciones']);
          this._archivosOrdenTaller = data.response['adjuntos'];
          this._archivosOrdenTallerFinal = [... this._archivosOrdenTaller];
          this.setDataInfo();
          this.Notificacion.ShowToasta("Operación existosa registro " + this.orden.folio, TipoToasta.EXITO);
          this._hayCambios = true;
        } else {
          this.Notificacion.ShowToasta(data.message, TipoToasta.ERROR);
        }
      }, error => {
        this.Notificacion.ShowToasta(error.message, TipoToasta.ERROR);
      }).add(() => {
        this.settings.loadingSpinner = false;
      });
  }

  refresh(res) {
    this.orden = res.orden;
    this.proveedor = res.proveedor
    this.AgregarListadoRefacciones(res.refacciones);
    this._archivosOrdenTaller = this.adjuntos;
    this._registradoPor = res.ordenTaller.registradoNombre;
    this.getUnidadInfo(this.orden.id_unidad)
      .subscribe(res => {
        this.unidadInfo = res;
      })
    this.getOrdenTallerFallaUnidad(this.orden.id_unidad)
      .subscribe(res => {
        this.AgregarReporteFallasList(res.response);
      });
    this.validaEstatus();
  }

  private AgregarListadoRefacciones(arr: Array<any>) {
    this.refaccionesList = [];
    for (const val of arr) {
      this.refaccionesList.push({
        editar: false,
        nuevo: false,
        id_orden_refaccion: val.id_orden_refaccion,
        id_orden: val.id_orden,
        id_accion: val.id_accion,
        accion: val.accion,
        id_sistema: val.id_sistema,
        sistema: val.sistema,
        id_componente: val.id_componente,
        componente: val.componente,
        id_refaccion: val.id_refaccion,
        refaccion: val.refaccion,
        cantidad: val.cantidad,
        id_unidadmedida: val.id_unidadmedida,
        unidadmedida: val.unidadmedida,
        precio_unitario: val.precio_unitario,
        importe: val.importe,
        factor_descuento: val.factor_descuento,
        monto_descuento: val.monto_descuento,
        total: val.total,
        id_falla: val.id_falla,
        id_falla_detalle: val.id_falla_detalle,
        acciones: val.acciones
      })
    }
    this.refaccionesList = [...this.refaccionesList];
  }

  public SetInformacionOrden () {
    let fecha = this.utilsSrv.GetLocalISODateTime(Date.now()).split('T');
    if( this.orden.id_orden == -1) {
      this.orden.fecha_captura = fecha[0] + ' ' + fecha[1].substring(0, 8);
      this.orden.fecha_registro = fecha[0] + ' ' + fecha[1].substring(0, 8);
    }
    this.orden.id_unidad = this.unidadInfo.idUnidad;
    this.orden.id_accion = this.accionSelected.id;
    this.orden.accion = this.accionSelected.value;
    this.orden.id_tipo_mtto = this.tipoMttoSelected.id;
    this.orden.fecha_inicio = this.fechaInicio.value.toISOString().slice(0, 10);
    this.orden.fecha_fin = this.fechaFin.value.toISOString().slice(0, 10);
    this.orden.id_registradopor = parseInt(this.myStorage.getItem('id_usuario'));
    this.orden.id_estatus_taller = this.estatusTallerSelected.id;
    this.orden.id_servicio = this.servicioSelected.id;
  }

  GetTime(ev: string, ctrl: string) {
    switch (ctrl) {
      case 'HoraInicio': this.orden.hora_inicio = ev; break;
      case 'HoraFin': this.orden.hora_fin = ev; break;
      case 'HoraProgramacion': this.horaProgramacion = ev; break;
      default: break;
    }
  }

  public stringToTimeSpan(str: string) {
    const [hours, minutes] = str.split(':');
    this.timeSpan.setHours(Number(hours), Number(minutes));
    return this.timeSpan.getHours() + ':' + this.timeSpan.getMinutes();
  }

  GetOrdenTallerDetalle(id_orden: number) {
    let params = {
      id_ordenDeTaller: id_orden
    }
    return this.connSvc.postAPI(this.NameController, "GetOrdenDeTaller", params)
      .pipe(
        map(result => {
          return result;
        }), catchError(err => {
          this.Notificacion.ShowToasta(err.error.message, TipoToasta.ERROR);
          return throwError(err)
        })
      );
  }

  get mergeModel(): any {
    return {
      ...this.orden,
    };
  }

  public updateModelCatalog(prop: string, ev: any) {
    this.refaccionesList = [];
    this.fallasUnidad = [];
    this.orden[prop] = ev.id
    if(ev.id > 0) {
      switch (prop) {
        case 'unidadId':
          this.getUnidadInfo(ev.id)
            .subscribe(res => {
              this.unidadInfo = res;
            });
          this.getOrdenTallerFallaUnidad(ev.id)
            .subscribe(res => {
              this.AgregarReporteFallasList(res.response);
            });
          break;
      }
    }
  }

  private AgregarReporteFallasList(arr: Array<any>) {
    for (const val of arr) {
      this.fallasUnidad.push({
        editar: false,
        nuevo: false,
        id_unidad: val.id_unidad,
        fecha_registro: val.fecha_registro.toString().slice(0, 10),
        fecha_programacion: val.fecha_programacion.toString().slice(0, 10),
        id_falla_detalle: val.id_falla_detalle,
        id_falla: val.id_falla,
        id_sistema: val.id_sistema,
        sistema: val.sistema,
        id_componente: val.id_componente,
        componente: val.componente,
        descripcion: val.descripcion,
        atendido: val.atendido,
        id_imagen: val.id_imagen,
        imagen: val.imagen,
        imgPath: val.imgPath
      })
    }
    this.fallasUnidad = [...this.fallasUnidad];
  }

 setTodayDateTime() {
    var tdate: any = new Date();
    var dia: any = tdate.getDate();

    if (dia < 10) {
      dia = "0" + dia;
    }
    var mes: any = tdate.getMonth() + 1;
    if (mes < 10) {
      mes = "0" + mes;
    }
    var anio: any = tdate.getFullYear();
    var horas: any = tdate.getHours();
    if (horas < 10) {
      horas = "0" + horas;
    }
    var minutos: any = tdate.getMinutes();
    if (minutos < 10) {
      minutos = "0" + minutos;
    }
    return anio + "-" + mes + "-" + dia + "T" + horas + ":" + minutos;
  }

  private getUnidadInfo(id) {
    let params = {
      id_unidad: id
    }
    return this.connSvc.postAPI(this.NameController, "GetUnidadInformacion", params)
      .pipe(
        map(result => {
          let res = result.response;
          return res;
        }), catchError(err => {
          this.Notificacion.ShowToasta(err.error.message, TipoToasta.ERROR);
          return throwError(err)
        })
      );
  }

  private getOrdenTallerFallaUnidad(id) {
    let params = {
      id_unidad: id
    }
    return this.connSvc.postAPI(this.NameController, "GetOrdenDeFallasFallaUnidad", params)
      .pipe(
        map(result => {
          // console.log(result);
          return result;
        }), catchError(err => {
          this.Notificacion.ShowToasta(err.error.message, TipoToasta.ERROR);
          return throwError(err)
        })
      );
  }

  public validaEstatus() {
    switch (this.orden.id_estatus) {
      case 1:
        this.claseEstatus = 'estatusEdicion';
        this.estatusTexto = 'Edición';
        break;
      case 2:
        this.claseEstatus = 'estatusAceptado';
        this.estatusTexto = 'Aceptado';
        break;
      case 3:
        this.claseEstatus = 'estatusCancelado';
        this.estatusTexto = 'Cancelado';
        break;
    }
  }

  private ValidarDatosListaComponentes(arr: Array<any>) {
    if (arr.length > 0) {
      for (const val of arr) {
        if(val.id_accion <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        if (val.id_sistema <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        if (val.id_componente <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        if (val.id_refaccion <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        if (val.cantidad <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        if (val.id_unidadmedida <= 0) {
          this.EditRefaccionEspecial(val);
          return;
        }
        // if (val.precio_unitario <= 0) {
        //   this.EditRefaccionEspecial(val);
        //   return;
        // }
      }
      this.realizarCalculo = true;
    }
  }

  private ValidarListas(accion: number, arr: Array<any>) {
    if (arr.length > 0) {
      for (const val of arr) {
        switch (accion) {
          case 1: //Validar lista de componentes a fallas.
            if (this.refaccionesList.filter(i => i.id_falla == val.id_falla && i.id_falla_detalle == val.id_falla_detalle).length > 0) {
              val.atendido = true;
            } else {
              val.atendido = false;
            }
            break;
          case 2: //Validar lista de fallas a componentes.
            if (val.atendido) {
              if (this.refaccionesList.filter(i => i.id_falla == val.id_falla && i.id_falla_detalle == val.id_falla_detalle).length <= 0) {
                //Agregamos fila
                this.refaccionesList.push({
                  editar: false,
                  nuevo: false,
                  id_orden_refaccion: 0,
                  id_orden: 0,
                  id_accion: 0,
                  accion: null,
                  id_sistema: val.id_sistema,
                  sistema: val.sistema,
                  id_componente: val.id_componente,
                  componente: val.componente,
                  id_refaccion: 0,
                  refaccion: null,
                  cantidad: 0,
                  id_unidadmedida: 0,
                  unidadmedida: null,
                  precio_unitario: 0,
                  importe: 0,
                  factor_descuento: 0,
                  monto_descuento: 0,
                  total: 0,
                  acciones: "I",
                  id_falla: val.id_falla,
                  id_falla_detalle: val.id_falla_detalle
                })
                this.accionSelected = {};
                this.sistemaSelected = {};
                this.componenteSelected = {};
                this.refaccionSelected = {};
                this.unidadMedidaSelected = {};
                this.refaccionesList = [...this.refaccionesList];
              }
            } else {
              if (this.refaccionesList.filter(i => i.id_falla == val.id_falla && i.id_falla_detalle == val.id_falla_detalle).length > 0) {
                //Eliminar fila
                this.refaccionesList = this.refaccionesList.filter(i => i.id_falla != val.id_falla && i.id_falla_detalle != val.id_falla_detalle);
                this.refaccionesList = [...this.refaccionesList];
              }
            }
            break;
        }
      }
    }
  }

  public MostrarDialogFallasUnidad() {
    //Validamos lista de componentes contra reporte fallas.
    this.ValidarListas(1, this.fallasUnidad);
    let dialogRef = this.dialog.open(dialogAddComponenteOrdenTaller, {
      data: { fallasUnidad : this.fallasUnidad },
      width: '60%',
      height: '425px',
      disableClose: true,
      panelClass: 'myapp-no-padding-dialog'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result);
        //validamos lista de fallas contra lista de componentes.
        this.ValidarListas(2, result);
        this.ValidarDatosListaComponentes(this.refaccionesList);
      }
    });
  }

  //#region Sección Archivos adjuntos.
  SubirArchivo(archivo?: any) {
    //this.displayToasta = false;
    let dialogRef = this.dialog.open(DialogSubirArchivo,
      {
        minWidth: "40vw",
        minHeight: "20vh",
        data: { archivo: { nombre: archivo?.nombre || '', descripcion: archivo?.descripcion || '' }, adjunto: archivo?.file || null }
      }
    )

    dialogRef.afterClosed().subscribe(result => {
      //this.displayToasta = true;
      if (result) {
        //result.rowNo = archivo ? archivo.rowNo : this._archivosOrdenTaller.length;
        if (this._archivosOrdenTaller.length == 0) {
          result.rowNo = 0;
          result.consecutivo = 1;
        } else {
          result.rowNo = this._archivosOrdenTaller[this._archivosOrdenTaller.length - 1].rowNo + 1;
          result.consecutivo = this._archivosOrdenTaller[this._archivosOrdenTaller.length - 1].consecutivo + 1;
        }
        result.acciones = "I";
        result.imgPath = "";
        let typeDocument = result.nombre.split('.');
        result.tipoDocumento = typeDocument[typeDocument.length - 1];
        if (archivo) {
          this._archivosOrdenTaller[archivo.rowNo] = { ...result }
          this._archivosOrdenTaller = [... this._archivosOrdenTaller];
        } else {
          this._archivosOrdenTaller.push(result);
          this._archivosOrdenTaller = [... this._archivosOrdenTaller];
        }
      }
    })
  }

  public VerDocumento(doc) {
    if (doc.nombre != '') {
      window.open(doc.imgPath, '_blank');
    }
  }

  public EliminarDocumento(doc) {
    let dialogConfRef = this.dialog.open(DialogConfirmacion, {
      data: { titulo: "Confirmación", mensaje: "¿Desea eliminar este archivo?", tipo: 2, confirm: false },
      width: '33%'
    });


    dialogConfRef.afterClosed().subscribe(res => {
      if (!!res) {
        if (res.confirm) {
          let arr = this._archivosOrdenTaller.filter(archivo => archivo.rowNo != doc.rowNo);
          this._archivosOrdenTaller = [...arr];
        }
      }
    })
  }
  //#endregion

  public onCloseClick() {
    this.dialogRef.close(this._hayCambios);
  }

}
